import React, { Fragment, useState } from 'react';
import gem from '../../../Dashboard/images/gem.svg';
import { Button, Modal } from '@squirrellearningltd/go-pupil-components';
import BuyCard from '../BuyCard';
import ImageFadeIn from "react-image-fade-in";

import styles from './CardLocked.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const CardLocked = ({ selectedPack, card, setFlipAnimation, canBuyWinner }) => {

    const { t } = useTranslation(['rewardcards', 'translation']);
    const [buyCard, setBuyCard] = useState();
    
    return( selectedPack  ?
        <Fragment>
            <div onClick={() => setBuyCard(card)}  className={styles.cardImg}>
                <img
                    src={selectedPack?.coverImageUrl}
                    alt=''
                    style={{
                        width: '100%',
                        objectFit: 'cover'
                    }}
                />
                {/* { ((selectedPack.key !== 'vegetable_friends') && (selectedPack.key !== 'mystic_artifacts')) && <span className={styles.cardName}>{t(selectedPack.key)}</span>}   */}
            </div>  
             <Button outline onClick={() => setBuyCard(card)} className={cx(styles.cardPrice, {[styles.cardPriceLocked]: card.chapterWinnerOnly})}>
                <Fragment>
                    <img src={gem} alt=''/> {card.price === 1  ? `${card.price} ${t('translation:gem')}` : `${card.price} ${t('translation:gems')}`}
                </Fragment>
            </Button>  
            {
                buyCard && (
                    <Modal closeModal={() => setBuyCard(null)}>
                        <BuyCard canBuyWinner={canBuyWinner} setFlipAnimation={setFlipAnimation} selectedPack={selectedPack} card={buyCard} closeModal={() => setBuyCard(null)} />
                    </Modal>
                )
            } 
        </Fragment> : null
    )
}

export default CardLocked;